<lib-icon-button
    [border]="showBorder"
    [borderColor]="showBorder ? color : ''"
    [backgroundColor]="showBorder ? backgroundColor : ''"
    iconName="chevron-left"
    display="circle"
    [color]="color"
    [rippleColor]="rippleColor"
    (onClick)="onButtonClick()" />
